import { render, staticRenderFns } from "./PccProgressNotesTab.vue?vue&type=template&id=c2fc65de&"
import script from "./PccProgressNotesTab.vue?vue&type=script&lang=js&"
export * from "./PccProgressNotesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports